import { render, staticRenderFns } from "./virtualProperty.vue?vue&type=template&id=6284c4d2&scoped=true"
import script from "./virtualProperty.vue?vue&type=script&lang=js"
export * from "./virtualProperty.vue?vue&type=script&lang=js"
import style0 from "./virtualProperty.vue?vue&type=style&index=0&id=6284c4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6284c4d2",
  null
  
)

export default component.exports